import React, {PropTypes, Component} from 'react'
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
momentDurationFormatSetup(moment)


class AttendanceLessonTime extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    attendenceInfo: PropTypes.object.isRequired
  }

  render(){
    let {attendenceInfo} = this.props
    let {lesson_start_datetime, lesson_end_datetime, check_in_state} = attendenceInfo

    return(
      <div className='class-status'>
        <span>
          {
            moment(lesson_start_datetime).format(__('MMM DD, YYYY', 'dateFormat')) + ' ' +
            moment(lesson_start_datetime).format('HH:mm') + ' - ' +
            moment(lesson_end_datetime).format('HH:mm')
          }
        </span>
        <span style={{paddingLeft: '10px'}}>
          {check_in_state == 1 && moment.duration(moment(lesson_end_datetime) - moment(lesson_start_datetime)).format('h [h] m [m]', {trim: 'all'})}
        </span>
      </div>
    )
  }
}


export default (AttendanceLessonTime)



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/Attendance/AttendanceLessonTime.js